module.exports = "mutation lockAdviceRequest($adviceRequestId:String!){lockAdviceRequest(adviceRequestId:$adviceRequestId)}"